import React from "react";
import { Accordion, Button, Card, Form, Modal, Spinner } from "react-bootstrap";
import { convertDateHour } from "../../utils/utilityFunctions";
import type { SimulationHistoryItem } from "./types";

interface HistoryModalProps {
  show: boolean;
  onHide: () => void;
  loading: boolean;
  history: SimulationHistoryItem[];
  filteredHistory: SimulationHistoryItem[];
  filter: string;
  onFilterChange: (value: string) => void;
  /** Exibe o botão "Inserir dados" (apenas fora da tela de resultado). */
  canRestore: boolean;
  onRestore: (item: SimulationHistoryItem) => void;
}

export const HistoryModal = ({
  show,
  onHide,
  loading,
  history,
  filteredHistory,
  filter,
  onFilterChange,
  canRestore,
  onRestore,
}: HistoryModalProps) => (
  <Modal
    show={show}
    onHide={onHide}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="simulacao-header-title">
          <h1>Histórico de simulações</h1>
          <h2>
            Veja o seu histórico de simulações salvas e insira os dados de uma
            simulação anterior no formulário
          </h2>
        </div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spinner animation="border" />
        </div>
      ) : history.length > 0 ? (
        <>
          <Form.Control
            placeholder="Digite nome ou CNPJ do cliente para filtrar histórico"
            className="mb-3"
            value={filter}
            onChange={({ target }) => onFilterChange(target.value)}
          />
          <div style={{ maxHeight: "40dvh", overflowY: "auto" }}>
            <div className="d-flex justify-content-end">
              <span
                style={{
                  color: "#212322",
                  fontWeight: 300,
                  marginRight: "4px",
                }}
              >
                {filteredHistory.length > 100
                  ? "100+ simulações"
                  : filteredHistory.length +
                    (filteredHistory.length !== 1
                      ? " simulações"
                      : " simulação")}
              </span>
            </div>

            <Accordion defaultActiveKey="0">
              {filteredHistory.map(
                (item, index) =>
                  index < 100 && (
                    <Card key={index}>
                      <Accordion.Toggle
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        as={Card.Header}
                        eventKey={String(index)}
                      >
                        <div>
                          {item.nomeCliente && item.nomeCliente} {item.cnpj} -{" "}
                          {item.simulationType} -{" "}
                          {item.simulation_date
                            ? convertDateHour(item.simulation_date)
                            : ""}{" "}
                          - ({item.partner_name && item.partner_name})
                        </div>

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#000000"
                        >
                          <path d="M440-800v487L216-537l-56 57 320 320 320-320-56-57-224 224v-487h-80Z" />
                        </svg>
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey={String(index)}>
                        <Card.Body>
                          <div className="accordion-body">
                            <div>
                              {item.distribuidora} - {item.ths} -{" "}
                              {item.grupoTarifario} <br />
                              Simulação: {item.simulationType} <br />
                              Contratação:{" "}
                              {String(item.tipoContratacao ?? "").replace(
                                /^./,
                                (firstLetter) => firstLetter.toUpperCase()
                              )}{" "}
                              <br />
                              Desconto: {Number(item.desconto) * 100}% <br />
                              Anos simulados: {item.quantidadeAnos || "5"}
                              <br />
                            </div>

                            <div>
                              Demanda contratada: {item.demandaForaPonta} kW /{" "}
                              {item.demandaPonta} kW <br />
                              Consumo fora ponta: {
                                item.consumoForaPonta
                              } kWh <br />
                              Consumo ponta: {item.consumoPonta} kWh <br />
                              Preço de energia:{" "}
                              {Array.isArray(item.precoEnergia)
                                ? item.precoEnergia
                                    .slice(0, 5)
                                    .map((price: string) => `R$ ${price}`)
                                    .join(" / ")
                                : `R$ ${item.precoEnergia1} / R$
                            ${item.precoEnergia2} / R$ ${item.precoEnergia3} / R$
                            ${item.precoEnergia4} / R$ ${item.precoEnergia5}`}
                              <br />
                            </div>
                          </div>
                          {canRestore && (
                            <div className="accordion-button">
                              <Button
                                style={{
                                  opacity: !Array.isArray(item.precoEnergia)
                                    ? 0.5
                                    : 1,
                                  cursor: !Array.isArray(item.precoEnergia)
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                disabled={!Array.isArray(item.precoEnergia)}
                                onClick={() => onRestore(item)}
                              >
                                Inserir dados
                              </Button>
                            </div>
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  )
              )}
            </Accordion>
          </div>
        </>
      ) : (
        <p>Você ainda não tem simulações.</p>
      )}
    </Modal.Body>
  </Modal>
);
